module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10227.58e17f36.jpg";